import "./App.css";
import Login from "./pages/Login";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { theme } from "./styles/theme";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Convenio from "./pages/Convenio";
import { Buffer } from "buffer";
import { BaseLayout } from "./components/BaseLayout";
import Logout from "./pages/Logout";
import TwoFactor from "./pages/TwoFactorAuth";
import { ToastContainer } from "react-toastify";

if (window.Buffer === undefined) window.Buffer = Buffer;

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <ToastContainer />
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <BaseLayout pageTitle={"Login"}>
                  <Login />
                </BaseLayout>
              }
            />
            <Route
              path="/auth/context"
              element={
                <BaseLayout pageTitle={"Convênios"}>
                  <Convenio />
                </BaseLayout>
              }
            />
            <Route
              path="/auth/login"
              element={
                <BaseLayout pageTitle={"Logout"} isLogout={true}>
                  <Logout />
                </BaseLayout>
              }
            />
            <Route
              path="/auth/two-factor"
              element={
                <BaseLayout pageTitle={"Código de verificação"}>
                  <TwoFactor />
                </BaseLayout>
              }
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
